import {TaskModel} from '.';
import {UserListingModel} from '../user';
import {DemandDescHtml , DemandListing} from '../demand';
import {CommonObjectModel} from '../common';
import {PersonListingModel} from '../person';
import {IPropertyListingModel , PropertyListingModel} from '../property';
import {BaseTranslation , IBaseTranslation} from "../base-translation";

export class TaskDetailModel extends TaskModel {
	
	Alarm?: boolean;
	AttachAType?: number;
	AttachBType?: number;
	Comment?: string;
	CreatedDate?: string;
	CreatedUserId?: number;
	Date?: string;
	DemandId?: number;
	DemandRef?: string;
	Description?: string;
	Duration?: number;
	DurationAlarm?: number;
	Email?: string;
	EmailConfirm?: number;
	EntryId?: string;
	Id?: number;
	IsDeleted?: boolean;
	IsDone?: boolean;
	IsExcludeFromReport?: boolean;
	IsTouched?: boolean;
	MainMessageType?: number;
	ModifiedDate?: string;
	ModifiedUserId?: number;
	ObjectId?: number;
	ObjectRef?: string;
	OrigId?: number;
	OriginContactId?: number;
	ParentTaskId?: number;
	PersonId?: number;
	PersonRef?: string;
	PrintId?: number;
	RecurrenceId?: number;
	RecurrencePatternInfo?: string;
	Sent?: boolean;
	StartTime?: string;
	Status?: number;
	Subject?: string;
	TaskCode?: number;
	TypeId?: number;
	UserId?: number;
	
	CreatedUserInfo: UserListingModel;
	DemandDescHtml: DemandDescHtml[];
	DemandPersonInfo: DemandListing;
	ModifiedUserInfo: UserListingModel;
	OriginContactInfo: CommonObjectModel;
	PersonInfo: PersonListingModel;
	PropertyInfo: IPropertyListingModel;
	TypeInfo: IBaseTranslation;
	UserInfo: UserListingModel;
	
	constructor(props) {
		super(props);
		this.CreatedUserInfo = props.CreatedUserInfo || new UserListingModel({
			ShortName: null ,
			Name: null
		});
		this.DemandDescHtml = props.DemandDescHtml || [new DemandDescHtml()];
		this.DemandPersonInfo = props.DemandPersonInfo || new PersonListingModel({
			Email: null,
			Language: null,
			Name: null,
			PhoneNumber: null,
			Reference: null
		});
		this.ModifiedUserInfo = props.ModifiedUserInfo || new UserListingModel({
			ShortName: null ,
			Name: null
		});
		this.OriginContactInfo = props.OriginContactInfo || new CommonObjectModel({
			Id: -1 ,
			Reference: null
		});
		this.PersonInfo = props.PersonInfo || new PersonListingModel({
			Email: null,
			Language: null,
			Name: null,
			PhoneNumber: null,
			Reference: null
		});
		this.PropertyInfo = props.PropertyInfo || new PropertyListingModel({
			Reference: null
		});
		this.TypeInfo = props.TypeInfo || new BaseTranslation({
			NameEN: null,
			NameFR: null,
			NameNL: null
		});
		this.UserInfo = props.UserInfo || new UserListingModel({
			Id: null,
			Name: null,
			ShortName: null
		});
		
		this.Alarm = props.Alarm || null;
		this.AttachAType = props.AttachAType || null;
		this.AttachBType = props.AttachBType || null;
		this.Comment = props.Comment || null;
		this.CreatedDate = props.CreatedDate || null;
		this.CreatedUserId = props.CreatedUserId || null;
		this.Date = props.Date || null;
		this.DemandId = props.DemandId || null;
		this.DemandRef = props.DemandRef || null;
		this.Description = props.Description || null;
		this.Duration = props.Duration || null;
		this.DurationAlarm = props.DurationAlarm || null;
		this.Email = props.Email || null;
		this.EmailConfirm = props.EmailConfirm || null;
		this.EntryId = props.EntryId || null;
		this.Id = props.Id || null;
		this.IsDeleted = props.IsDeleted || null;
		this.IsDone = props.IsDone || null;
		this.IsExcludeFromReport = props.IsExcludeFromReport || null;
		this.IsTouched = props.IsTouched || null;
		this.MainMessageType = props.MainMessageType || null;
		this.ModifiedDate = props.ModifiedDate || null;
		this.ModifiedUserId = props.ModifiedUserId || null;
		this.ObjectId = props.ObjectId || null;
		this.ObjectRef = props.ObjectRef || null;
		this.OrigId = props.OrigId || null;
		this.OriginContactId = props.OriginContactId || null;
		this.ParentTaskId = props.ParentTaskId || null;
		this.PersonId = props.PersonId || null;
		this.PersonRef = props.PersonRef || null;
		this.PrintId = props.PrintId || null;
		this.RecurrenceId = props.RecurrenceId || null;
		this.RecurrencePatternInfo = props.RecurrencePatternInfo || null;
		this.Sent = props.Sent || null;
		this.StartTime = props.StartTime || null;
		this.Status = props.Status || null;
		this.Subject = props.Subject || null;
		this.TaskCode = props.TaskCode || null;
		this.TypeId = props.TypeId || null;
		this.UserId = props.UserId || null;
	}
}

